import React from 'react'
import ProtectedPortalRoute from './ProtectedPortalRoute'
import withAuth from './withAuth'

const ProtectedPortalRouteWithAuth = props => {
  return <ProtectedPortalRoute {...props} />
}
export default withAuth(ProtectedPortalRouteWithAuth)



// WEBPACK FOOTER //
// ./src/components/templates/route-management/ProtectedPortalRouteWithAuth.js